import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { AIJobComponent } from './ai-job.component';
import { FormsModule } from '@angular/forms';
import { AIJobsListComponent } from './ai-jobs-list/ai-jobs-list.component';
import { AIJobsListFilter } from './ai-jobs-list/ai-jobs-list.filter';
import { AIJobsListFilterStatus } from './ai-jobs-list/ai-jobs-list.filterStatus';
import { AIJobsListFilterStatusExcecution } from './ai-jobs-list/ai-jobs-list.filterStatusExcecution';
import { AIJobsWrapperComponent } from './ai-jobs-wrapper/ai-jobs-wrapper.component';
import { AIJobsDescriptionComponent } from './ai-jobs-description/ai-jobs-description.component';
import { JobSettingsComponent } from './jobs/job-settings/job-settings.component';
import { ResultErrorsComponent } from './jobs/result-errors/result-errors.component';
import { JobsService } from './jobs/jobs.service';
import { JobsTableComponent } from './jobs/jobs-table/jobs-table.component';
import { JobsStepsComponent } from './jobs/jobs-steps/jobs-steps.component';
import { JobsFilterComponent } from './jobs/jobs-filter/jobs-filter.component';
import { JobsDetailComponent } from './jobs/jobs-detail/jobs-detail.component';
import { JobExecutionComponent } from './jobs/job-execution/job-execution.component';
import { JobSchedulesComponent } from './jobs/job-schedules/job-schedules.component';
import { AIJobsService } from './ai-jobs.service';
import { FilterModule } from 'app/shared/components/filter/filter.module';



export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    AIJobComponent,
    AIJobsListComponent,
    AIJobsWrapperComponent,
    AIJobsListFilter,
    AIJobsListFilterStatusExcecution,
    AIJobsListFilterStatus,
    AIJobsDescriptionComponent,
    JobSettingsComponent,
    ResultErrorsComponent,
    JobsTableComponent,
    JobsStepsComponent,
    JobsFilterComponent,
    JobsDetailComponent,
    JobExecutionComponent,
    JobSchedulesComponent,
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    CommonModule,
    SharedModule,
    FormsModule,
    FilterModule
  ],
  exports: [
    AIJobComponent   
  ],
  providers: [
    AIJobsService,
    JobsService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AIJobModule { }
